import React from 'react'

import styled from 'styled-components'

import DownloadBtn from '../styledComponents/DownloadBtn'

import { Container,Cell,Grid } from './'
import { device } from "../device"

const Header = styled.div`
    padding: 64px 0;

    background: #000;
    @media ${device.sm} {
        padding: 96px 0;
    }
    @media ${device.xl} {
        padding: 128px 0;
    }
    @media ${device.xxl} {
        padding: 148px 0;
    }
`;
const HeaderWrapper = styled.div`
    width: 100%;
    a, button {
        margin-top: 24px;
    }
    @media ${device.md} {
        align-items: center;
        display: flex;
        justify-content: space-between;
        a, button {
            margin-top: 24px;
        }
    }
`;
const Title = styled.h2`
    margin: 0;

    font-size: 32px;
    font-weight: 500;
    line-height: 1.2;

    color: var(--light-gray1);
    @media ${device.sm} {
        font-size: 48px;
    }
    @media ${device.lg} {
        font-size: 64px;
    }
    @media ${device.xl} {
        font-size: 72px;
    }
`;

const ChapterHeader = ({title, ...props}) => {

    return (
        <Header>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        {props.downloadLink
                            ?
                            <HeaderWrapper>
                                <Title>{title}</Title>
                                <DownloadBtn href={props.downloadLink} />
                            </HeaderWrapper>
                            : 
                            <Title>{title}{props.children}</Title>
                        }
                    </Cell>
                </Grid>
            </Container>
        </Header>
    )
};

export default ChapterHeader;